/**
 * Agency per-client website analytics (Google Analytics 4), read-only, through
 * /v1/connectors/agency/clients/:id/ga4/* (active grant with read:reports; assigned staff only; the client's
 * `connectors.ga4` flag). Agency owners / admins with a manage:campaigns grant also connect, reconnect and disconnect the
 * client's property here (ClientGa4Connect, ./ga4-connect.tsx); the client can still do it in their own workspace.
 */
import { useMemo } from 'react';
import { Link, useParams } from 'react-router';
import { createGa4Source } from '../../../ga4/logic';
import { Ga4View } from '../../../ga4/Ga4View';
import { useSurface } from '../kit/context';
import { Screen } from '../kit/ui';
import { ClientGa4Connect } from './ga4-connect';

export function ClientAnalyticsPage() {
  const { t, locale, now } = useSurface();
  const { id = '' } = useParams();
  const source = useMemo(() => createGa4Source({ kind: 'agency', clientId: id }), [id]);
  return (
    <Screen title={t('connectors.ga4.title')} subtitle={t('connectors.ga4.agencyIntro')} testId="client-analytics"
      actions={<Link className="qx-link" to={`/clients/${encodeURIComponent(id)}?tab=summary`}>{t('portal.partners.clients.detail')}</Link>}>
      <ClientGa4Connect tenantId={id} />
      <Ga4View source={source} t={t} locale={locale} now={now} integrationsHref={null} />
    </Screen>
  );
}
